/**
 * Animation timing tokens - sourced from theme configuration.
 *
 * All duration values flow from src/config/theme.config.ts (single source of truth).
 * This module re-exports them under their legacy names for backwards compatibility.
 */
import { defaultTheme } from '../config/theme.config';

// Animation timing tokens from theme configuration
export const ANIMATION_TOTAL_DURATION = defaultTheme.animation.totalAnimationDuration;

// Duration tokens (milliseconds) - sourced from theme config
export const DURATION_INSTANT = defaultTheme.animation.durations.instant;   // Micro-feedback
export const DURATION_FAST = defaultTheme.animation.durations.fast;         // Hover states
export const DURATION_NORMAL = defaultTheme.animation.durations.normal;     // Default transitions
export const DURATION_SLOW = defaultTheme.animation.durations.slow;         // Marker fade-in
export const DURATION_DRAMATIC = defaultTheme.animation.durations.dramatic; // Story reveals (Epic 2.2)

/**
 * Calculate the interval between each marker appearance
 * @param placeCount - Number of places to animate
 * @returns Interval in milliseconds
 */
export function calculateInterval(placeCount: number): number {
  if (placeCount <= 0) return 0;
  return ANIMATION_TOTAL_DURATION / placeCount;
}
